import {
  SET_SHOW_PRODUCT_STATUS_MODAL,
  SET_SINGLE_PRODUCT_DELETE_ROW_ID,
  SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID,
  SET_PRODUCT_LIST_ACTIVE_TAB,
  SET_IS_PRICE_AREA_UPDATE,
  SET_ACTIVE_INPUT_ID,
  SET_IS_PRICE_AREA_STATUS,
  SET_IS_PRICE_AREA_ERROR_MESSAGE,
} from "./mutation-types";
import Request from "@/services/request";
import {
  SELLER_DASHBOARD_QUERY,
  DELETE_PRODUCTS_URL,
  PRODUCT_GROUP_SEARCH,
  PRODUCT_IMAGES,
  OPEN_FOR_SALE,
  TEMPLATE_DOWNLOAD,
  VALIDATE_UPLOAD,
  CONFIRM_UPLOAD,
  EXPORT_EXCEL,
  PRODUCT_UPDATE,
  PRODUCT_LIST_SUMMARY,
  CHANGE_APPROVAL_STATUS_URL,
  HISTORY_TAB_DOWNLOAD_URL,
  CONFIRM_DEAL_UPLOAD,
  SUBMIT_SINGLE_PRODUCT,
  PRODUCT_IMAGE_UPLOAD,
  PRODUCT_DESCRIPTION,
  PRODUCT_NUTRITIONS,
  MANUFACTURER_ORIGIN_INFO,
  SAFETY_INFO_UPLOAD,
  PRODUCT_NUTRITION_OPTIONS,
} from "@/utils/enum/endpoints";

const request = new Request();

const getProductsModule = async ({ rootState }) => {
  try {
    const { sellerId } = rootState.auth.user;
    const { data } = await request.get(
      `${SELLER_DASHBOARD_QUERY}/${sellerId}?type=PRODUCTS_SUMMARY`
    );
    return data.PRODUCTS_SUMMARY;
  } catch (data) {
    return Promise.reject(data);
  }
};

const deleteProducts = async (_, payload) => {
  try {
    const { productIds, tabParam } = payload;
    const res = await request.delete(DELETE_PRODUCTS_URL, {
      productIds,
      tabParam,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductInfo = async (_, { groupId }) => {
  try {
    const res = await request.post(PRODUCT_GROUP_SEARCH, {
      productGroupId: groupId,
      page: 0,
      size: 1000,
    });
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductImages = async (_, pimsId) => {
  try {
    const res = await request.get(PRODUCT_IMAGES.replace("{id}", pimsId));
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const openForSale = async (
  _,
  { productGroupId, shipmentTemplate, productDetails }
) => {
  try {
    const requestPayload = {
      productGroupId,
      shipmentTemplate,
      productDetails,
    };

    const res = await request.post(OPEN_FOR_SALE, requestPayload);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const downloadProductTemplate = async (_, id) => {
  try {
    return await request.get(`${TEMPLATE_DOWNLOAD}?categoryId=${id}`);
  } catch (error) {
    return Promise.reject(error);
  }
};

const validateUpload = async (_, { file, type }) => {
  try {
    const { data } = await request.upload(
      VALIDATE_UPLOAD.replace("{type}", type.toLowerCase()),
      file
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const confirmUpload = async (_, id) => {
  try {
    const { data } = await request.post(`${CONFIRM_UPLOAD}/${id}`);
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const approveGIBSellerInfo = async ({ rootState }) => {
  try {
    const res = await request.post(
      rootState.common.checkGIBSellerInfoData.approveLink
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Actions for managing product modal states
const setShowProductStatusModal = ({ commit }, show) => {
  commit(SET_SHOW_PRODUCT_STATUS_MODAL, show);
};

const setSingleProductDeleteRowId = ({ commit }, rowId) => {
  commit(SET_SINGLE_PRODUCT_DELETE_ROW_ID, rowId);
};

const setSingleProductImageUploadRowId = ({ commit }, rowId) => {
  commit(SET_SINGLE_PRODUCT_IMAGE_UPLOAD_ROW_ID, rowId);
};

const setProductListActiveTab = ({ commit }, activeTab) => {
  commit(SET_PRODUCT_LIST_ACTIVE_TAB, activeTab);
};

// Product export and update functions
const requestExportExcel = async (_, payload) => {
  try {
    const requestPayload = Object.assign({}, payload);
    requestPayload.sellerStockCode = payload.stockCode || "";
    requestPayload.categoryIdList = payload.categoryIds || [];
    requestPayload.brandNameList = payload.brandName || [];
    requestPayload.gtin = payload.gtin || null;
    requestPayload.pimsId = payload.pimsId || null;
    requestPayload.productStatusList = payload.productStatus || [];
    requestPayload.saleStatus = payload?.saleStatus?.length
      ? payload.saleStatus[0]
      : null;
    delete requestPayload.stockCode;
    delete requestPayload.categoryIds;
    delete requestPayload.brandName;
    delete requestPayload.pageRequest;
    delete requestPayload.productStatus;

    const { data } = await request.post(
      `/endpoint-products/product-excel-export?tab=${payload?.tabParam}`,
      requestPayload
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

const requestExportExcelNew = async (_, payload) => {
  try {
    const requestPayload = Object.assign({}, payload);
    requestPayload.stockCode = payload.stockCode || null;
    requestPayload.categoryIds = payload.categoryIds || null;
    requestPayload.brandName = payload.brandName || null;
    requestPayload.gtin = payload.gtin || null;
    requestPayload.pimsId = payload.pimsId || null;
    requestPayload.productStatus = payload.productStatus || [];

    delete requestPayload.pageRequest;
    delete requestPayload.id;

    const { data } = await request.post(
      `${EXPORT_EXCEL}?tab=${payload?.tabParam}`,
      requestPayload
    );
    return Promise.resolve(data);
  } catch (e) {
    return Promise.reject(e);
  }
};

const getTabCount = async () => {
  try {
    const { data } = await request.get(`${PRODUCT_LIST_SUMMARY}`);
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const handleUpdate = async (
  { commit, rootState },
  { stockCode, stock, listPrice, salesPrice, id }
) => {
  try {
    const { sellerId } = rootState.auth.user;
    const { data } = await request.put(PRODUCT_UPDATE, {
      stockCode,
      stock,
      sellerId,
      listPrice: parseFloat(listPrice),
      salePrice: parseFloat(salesPrice),
      currencyType: "TL",
    });
    commit(SET_IS_PRICE_AREA_UPDATE, true);
    commit(SET_ACTIVE_INPUT_ID, id);
    commit(SET_IS_PRICE_AREA_STATUS, true);
    setTimeout(() => {
      commit(SET_IS_PRICE_AREA_UPDATE, false);
      commit(SET_IS_PRICE_AREA_STATUS, null);
    }, 0);
    return Promise.resolve(data);
  } catch (e) {
    commit(SET_IS_PRICE_AREA_STATUS, false);
    commit(SET_IS_PRICE_AREA_ERROR_MESSAGE, e.data.message);
    return Promise.reject(e);
  }
};

const changeProductsApproveStatus = async (_, payload) => {
  try {
    const { productIds, productStatus, tabParam } = payload;
    const res = await request.put(CHANGE_APPROVAL_STATUS_URL, {
      productIds,
      productStatus,
      tabParam,
    });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getExportProductJobDetail = async (_, batchId) => {
  try {
    const res = await request.get(`${HISTORY_TAB_DOWNLOAD_URL}/${batchId}`);
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const confirmDealUpload = async (
  { rootState },
  { file, offerPeriodStart, offerPeriodEnd }
) => {
  const { sellerId } = rootState.auth.user;
  try {
    const { data } = await request.upload(
      `${CONFIRM_DEAL_UPLOAD.replace(
        "{sellerId}",
        sellerId
      )}?startDate=${offerPeriodStart}&finishDate=${offerPeriodEnd}`,
      file
    );
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getSubmitSingleProduct = async (_, payload) => {
  try {
    const { data } = await request.post(SUBMIT_SINGLE_PRODUCT, payload, {
      baseURL: "/selleroffice/rest",
      headers: {
        Accept: "application/json",
      },
    });
    return data;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const uploadProductImages = async (_, { productImages }) => {
  try {
    const resp = await request.post(PRODUCT_IMAGE_UPLOAD, productImages, {
      baseURL: "/selleroffice/rest",
      headers: { Accept: "application/json" },
      withCredentials: true,
    });
    return resp.data.images;
  } catch ({ data }) {
    return Promise.reject(data);
  }
};

const getProductDescription = async (_, categoryId) => {
  try {
    const { data } = await request.get(
      `${PRODUCT_DESCRIPTION}/${categoryId}`,
      null,
      {
        baseURL: "/selleroffice/rest",
        headers: {
          Accept: "application/json",
        },
      }
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductNutritions = async (_, { categoryId }) => {
  try {
    const res = await request.get(
      PRODUCT_NUTRITIONS.replace("{categoryId}", categoryId),
      null,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getManufacturerOriginInfo = async () => {
  try {
    const response = await request.get(MANUFACTURER_ORIGIN_INFO, null, {
      headers: {
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};

const uploadSafetyInfo = async (_, formData) => {
  try {
    const response = await request.post(SAFETY_INFO_UPLOAD, formData, {
      headers: {
        Accept: "application/json",
      },
      withCredentials: true,
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getProductNutritionOptions = async () => {
  try {
    const response = await request.post(
      PRODUCT_NUTRITION_OPTIONS,
      ["nutritional-values"],
      {
        headers: {
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  getProductsModule,
  deleteProducts,
  getProductInfo,
  getProductImages,
  openForSale,
  downloadProductTemplate,
  validateUpload,
  confirmUpload,
  approveGIBSellerInfo,
  setShowProductStatusModal,
  setSingleProductDeleteRowId,
  setSingleProductImageUploadRowId,
  setProductListActiveTab,
  requestExportExcel,
  requestExportExcelNew,
  getTabCount,
  handleUpdate,
  changeProductsApproveStatus,
  getExportProductJobDetail,
  confirmDealUpload,
  getSubmitSingleProduct,
  uploadProductImages,
  getProductDescription,
  getProductNutritions,
  getManufacturerOriginInfo,
  uploadSafetyInfo,
  getProductNutritionOptions,
};
